import { jsx as _jsx } from "react/jsx-runtime";
import { Web3Provider } from '@ethersproject/providers';
import { Web3ReactProvider } from '@web3-react/core';
var DEFAULT_POLLING_INTERVAL = 15000;
export function EthersProvider(_ref) {
  var children = _ref.children,
      pollingInterval = _ref.pollingInterval;

  function getLibrary(provider) {
    var library = new Web3Provider(provider, 'any');
    library.pollingInterval = pollingInterval || DEFAULT_POLLING_INTERVAL;
    return library;
  }

  return _jsx(Web3ReactProvider, Object.assign({
    getLibrary: getLibrary
  }, {
    children: children
  }), void 0);
}